import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import Tabla from '../Tabla';
import MatchList from '../MatchList';
import MatchCardGroup from '../MatchCardGroup';
import Players from '../Players';
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';
class Tercera1996 extends React.Component {

  constructor(props){
    super(props);
        this.comeBack = this.comeBack.bind(this);
	this.handleChange = this.handleChange.bind(this);
	var id_list = [];
	for (var i = 55; i <= 88; i++) {
        	id_list.push(i);
        }
    this.state = {
	showCards: true,
      path: this.props.path,
      ctype: this.props.ctype,
      torneo: this.props.torneo,
      id_list: id_list,
      table0:[
              {'color':'#295e1e','shortname':'iberia', 'rivalName':'Iberia', 'pj':18, 'pg':10,'pe':6,'pp':2,'gf':32,'gc':15,'dif':17, 'pts':36},
              {'color':'#295e1e','shortname':'udeconce', 'rivalName':'U. de Concepción', 'pj':18, 'pg':10,'pe':5,'pp':3,'gf':32,'gc':18,'dif':14, 'pts':35},
	      {'color':'#295e1e','shortname':'malleco', 'rivalName':'Malleco', 'pj':18, 'pg':10,'pe':5,'pp':3,'gf':31,'gc':17,'dif':14, 'pts':35},
	      {'color':'#295e1e','shortname':'naval', 'rivalName':'Dep. Talcahuano', 'pj':18, 'pg':11,'pe':4,'pp':3,'gf':39,'gc':17,'dif':22, 'pts':37},
	      {'color':'#ff3355','shortname':'launion', 'rivalName':'Dep. La Unión', 'pj':18, 'pg':7,'pe':8,'pp':3,'gf':35,'gc':24,'dif':1, 'pts':29},
	      {'color':'#ff3355','shortname':'animas', 'rivalName':'Dep. Las Ánimas', 'pj':18, 'pg':5,'pe':4,'pp':9,'gf':22,'gc':25,'dif':-3, 'pts':19},
	      {'color':'#ff3355','shortname':'uss', 'rivalName':'U. San Sebastián', 'pj':18, 'pg':5,'pe':4,'pp':9,'gf':19,'gc':30,'dif':-11, 'pts':19},
	      {'color':'#ff3355','shortname':'mulchen', 'rivalName':'Mulchén U.', 'pj':18, 'pg':2,'pe':4,'pp':12,'gf':16,'gc':43,'dif':-27, 'pts':10},
              {'color':'#ff3355','shortname':'laja', 'rivalName':'Dep. Laja', 'pj':18, 'pg':2,'pe':4,'pp':12,'gf':15,'gc':45,'dif':-30, 'pts':10},
	      {'color':'#ff3355','shortname':'deplota', 'rivalName':'Dep. Lota', 'pj':18, 'pg':4,'pe':4,'pp':10,'gf':21,'gc':29,'dif':-8, 'pts':16}],

	table1:[
              {'color':'#295e1e','shortname':'morning', 'rivalName':'S. Morning', 'pj':10, 'pg':7,'pe':1,'pp':2,'gf':22,'gc':12,'dif':10, 'pts':22},
              {'color':'#295e1e','shortname':'udeconce', 'rivalName':'U. de Concepción', 'pj':10, 'pg':4,'pe':5,'pp':1,'gf':11,'gc':6,'dif':5, 'pts':17},
              {'color':0,'shortname':'iberia', 'rivalName':'Iberia', 'pj':10, 'pg':3,'pe':4,'pp':3,'gf':15,'gc':14,'dif':1, 'pts':13},
              {'color':0,'shortname':'gv', 'rivalName':'G. Velásquez', 'pj':10, 'pg':3,'pe':3,'pp':4,'gf':14,'gc':15,'dif':-1, 'pts':12},
              {'color':0,'shortname':'malleco', 'rivalName':'Malleco', 'pj':10, 'pg':2,'pe':2,'pp':6,'gf':13,'gc':20,'dif':-7, 'pts':8},
              {'color':0,'shortname':'naval', 'rivalName':'Dep. Talcahuano', 'pj':10, 'pg':2,'pe':3,'pp':5,'gf':11,'gc':19,'dif':-8, 'pts':9}],

	table2:[
              {'color':0,'shortname':'lacalera', 'rivalName':'U. La Calera', 'pj':6, 'pg':2,'pe':2,'pp':2,'gf':10,'gc':7,'dif':3, 'pts':8},
              {'color':0,'shortname':'udeconce', 'rivalName':'U. de Concepción', 'pj':6, 'pg':2,'pe':2,'pp':2,'gf':10,'gc':6,'dif':4, 'pts':8},
              {'color':'#295e1e','shortname':'morning', 'rivalName':'S. Morning', 'pj':6, 'pg':4,'pe':0,'pp':2,'gf':13,'gc':9,'dif':4, 'pts':12},
              {'color':0,'shortname':'sanluis', 'rivalName':'San Luis', 'pj':6, 'pg':2,'pe':0,'pp':4,'gf':5,'gc':16,'dif':-11, 'pts':6}],

    };
  }

  componentDidMount() {
	let newtable = this.sortTable(this.state.table1);
                this.setState({table1:newtable});

	let newtable2 = this.sortTable(this.state.table2);
                this.setState({table2:newtable2});
	let newtable0 = this.sortTable(this.state.table0);
                this.setState({table0:newtable0});
        }



  handleChange(val){
    console.log(val);
    if(val===1){
      this.setState({showCards:true});
    }
    else{
      this.setState({showCards:false});
    }
  }

comeBack(){
this.setState({path:this.state.path});
}

subText(color, text){

let comp = [];
comp.push(

	<Row className="justify-content-md-center">
            <Col lg={2} xl={2} >

        <Table bordered={ false } size="sm">
        <tr style={{border: 'none', textAlign: 'rigth' }}>
        <td bgcolor={color}>
        </td>
        <td style={{border: 'none', textAlign: 'center'}}> {text} </td>
        </tr>
        </Table>
        </Col>
        </Row>



)
return comp;

}

sortTable(table){
       let aux;
      for(let i=table.length-1;i>0;i--){
             for(let j =0; j<i; j++){
                 if( (table[j].pts < table[j+1].pts) || 
                     ((table[j].pts === table[j+1].pts) && (table[j].dif < table[j+1].dif)) ||
                     ((table[j].pts === table[j+1].pts) && (table[j].dif === table[j+1].dif) && (table[j].gf < table[j+1].gf))){
                        aux = table[j+1];
                        table[j+1] = table[j];
                        table[j] = aux;
                } 
             }          
        }
return table;

}




render(){

  let subB = this.subText('#295e1e', 'Asciende a Primera B 1997');
  let subA = this.subText('#295e1e', 'Clasifica a Fase 2 Ascenso');
  let subP = this.subText('#295e1e', 'Clasifica a Liguilla de Ascenso');
  let subD = this.subText('#ff3355', 'Clasifica a Fase 2 Descenso');

console.log(this.state.id_list)

  return(

	<div style={{textAlign: 'center' }}>
      <div style={{ height: '50px' }}></div>
	<div className="mytitlepartidos"> Fase 1 Grupo Sur </div>
	<div style={{ height: '10px' }}></div>
	{<Tabla teams={this.state.table0} />}
	<div style={{ height: '10px' }}></div>
	{subA}
	{subD}
	<div style={{ height: '50px' }}></div>
	<div className="mytitlepartidos"> Fase 2 Grupo Sur</div>
	<div style={{ height: '10px' }}></div>
        {<Tabla teams={this.state.table1} />}
        <div style={{ height: '10px' }}></div>
         {subP}
	<div style={{ height: '50px' }}></div>
        <div className="mytitlepartidos"> Liguilla Ascenso</div>
        <div style={{ height: '10px' }}></div>
        {<Tabla teams={this.state.table2} />}
        <div style={{ height: '10px' }}></div>
         {subB}
	 

	
	<div style={{ height: '100px' }}></div>
	<div className="mytitlepartidos">  Partidos UDEC Tercera 1996</div>
	<div style={{ height: '10px' }}></div>

	<ToggleButtonGroup type="radio" name="options" defaultValue={1} onChange={this.handleChange}>
            <ToggleButton variant="secondary" value={1}>Tarjetas</ToggleButton>
            <ToggleButton variant="secondary" value={2}>Listado</ToggleButton>
          </ToggleButtonGroup>
	 <div style={{ height: '10px' }}></div>
	<Container>
	<div className={this.state.showCards ? '': 'hiddenCard'}>
           <MatchCardGroup id_list={this.state.id_list}></MatchCardGroup>
         </div>
         <div className={this.state.showCards ? 'hiddenCard': ''}>

           <MatchList id_list={this.state.id_list} showName={true}></MatchList>

         </div>
	</Container>

	<div style={{ height: '100px' }}></div>
        <div className="mytitlepartidos">  Jugadores UDEC Tercera 1996</div>
        <div style={{ height: '10px' }}></div>

	<Players torneo="Tercera 1996" />
     </div>


  )
}

}
export default Tercera1996;
